import { PASSWORDS, PUBLIC_ORGANISATIONS } from 'src/api';
import axios from 'src/axios';
import { handleErrorToast } from 'src/components/molecules';

export const getOrganisation = async (
  slug: string,
  setLoading: React.Dispatch<React.SetStateAction<boolean>>,
  setNotFound: React.Dispatch<React.SetStateAction<boolean>>,
) => {
  try {
    const response = await axios.get(
      PUBLIC_ORGANISATIONS + '/' + slug.toLowerCase(),
    );
    if (response.status === 200) {
      setLoading(false);
    } else {
      setNotFound(true);
      setLoading(false);
    }
  } catch (error) {
    setNotFound(true);
    setLoading(false);
  }
};

export const createPassword = async (
  password: string,
  confirmPassword: string,
  error: string,
  token: string,
  setSubmitted: React.Dispatch<React.SetStateAction<boolean>>,
) => {
  if (!password || !confirmPassword) {
    handleErrorToast({ toastMessage: 'Please enter a password.' });
  } else if (!error) {
    try {
      const result = await axios.post(PASSWORDS, {
        password: password,
        confirmation: confirmPassword,
        token,
      });
      if (result.data.status === 201) {
        setSubmitted(true);
      } else {
        handleErrorToast({
          toastMessage: `Can't create password, invalid token.`,
        });
      }
    } catch (err) {
      handleErrorToast({
        toastMessage: `Can't create password, invalid token.`,
      });
    }
  }
};
